module.exports = __webpack_public_path__ + "img/information-title.c758cfe0.png";